import React from 'react';
import { Outlet } from 'react-router-dom';
import SideBar from './SideBar/SideBar';
import Header from './Header/Header';
import { ToastContainer } from 'react-toastify';
import AgentPrivateRoute from '../../../Route/AgentPrivateRoute';
const AgentHomeMain = () => {
    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />

            <AgentPrivateRoute>
                <div className="page-wrapper default-version">
                    <SideBar />
                    <Header />

                    <div className="body-wrapper">
                        <div className="bodywrapper__inner">

                            <Outlet></Outlet>


                        </div>
                    </div>
                </div>
            </AgentPrivateRoute>

        </>
    );
};

export default AgentHomeMain;